// The frame around the pages a visitor sees before signing in: the login page and the connect
// page. A brand panel in Relatude's navy says what this service is and what the page is for; the
// work happens in the panel beside it. On a phone the brand panel shrinks to a header.
import type { ReactNode } from 'react'
import { AnimatedLogo } from './AnimatedLogo'
import { Icon, ThemeToggle, type IconName } from './Ui'

export interface AuthPoint {
  icon: IconName
  title: string
  text: ReactNode
}

export function AuthLayout({ kicker = 'Relatude.License', title, lead, points, children }: { kicker?: string; title: string; lead: ReactNode; points: AuthPoint[]; children: ReactNode }) {
  return (
    <div className="auth">
      <aside className="auth-brand">
        <div className="auth-brand-inner">
          <div className="auth-logo">
            <AnimatedLogo height="46px" color="currentColor" speed={0.6} />
          </div>
          <div className="auth-kicker">{kicker}</div>
          <h2 className="auth-title">{title}</h2>
          <p className="auth-lead">{lead}</p>
          <ul className="auth-points">
            {points.map((p) => (
              <li key={p.title}>
                <span className="auth-point-icon">
                  <Icon name={p.icon} />
                </span>
                <div>
                  <strong>{p.title}</strong>
                  <span>{p.text}</span>
                </div>
              </li>
            ))}
          </ul>
          <footer className="auth-foot">
            <span>Relatude and Relatude.DB are made by Proventus AS.</span>
            <a href="https://relatude.com" target="_blank" rel="noreferrer">
              relatude.com <Icon name="external" size={13} />
            </a>
          </footer>
        </div>
      </aside>
      <main className="auth-main">
        <ThemeToggle className="auth-theme" />
        <div className="panel">{children}</div>
      </main>
    </div>
  )
}
